import * as types from '../../actions/actionTypes';

const defaultState = {
  data: null,
  selected: null,
  kdna: null,
  isLoadingCodebase: true,
};

export default (state = defaultState, action) => {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case types.FETCH_CODEBASES_SUCCESS:
      return { ...state, data: action.data };
    case types.FETCH_CODEBASE:
      return { ...state, selected: null, isLoadingCodebase: true };
    case types.FETCH_CODEBASE_SUCCESS:
      let codebase = action.data[0];
      return { ...state, selected: codebase, isLoadingCodebase: false };
    case types.FETCH_CODEBASE_FAILED:
      return { ...state, selected: null, isLoadingCodebase: false };
    case types.GET_KDNA_SUCCESS:
      return { ...state, kdna: action.data };
    case types.GET_KDNA_FAIL:
      return { ...state, kdna: action.data };
    default:
      return nextState;
  }
};
